<template>
    <tr class="p-grid p-col-12">
        <td  class="p-col">
            <h3>
            {{lesson.hebrewName}}
            </h3>
        </td>

        <th class="p-col" v-for="day in days">
            <schedule-item :loading="loading" :grade="grade" :day="day" :lesson="lesson" :schedule="getRowScheduleValue(day.id)" />
        </th>

    </tr>
</template>

<script>
import {mapState} from "vuex";
import ScheduleItem from "@/views/Schedule/ScheduleGrade/ScheduleItem";
import {days} from "@/views/Schedule/Schedule";

export default {
    name: "RowSchedule",
    components: {
        ScheduleItem,
    },
    props: {
        lesson: {
            type: Object,
            default: null,
        },
        grade: {
            type: String,
            default: null,
        },
        rowScheduleValue: {
            type: Object,
            default: null
         },
        loading: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        rowScheduleValue() {
            this.$forceUpdate()
        }
    },
    computed: {

        ...mapState(["lessonTime", "subjectLesson"]),
    },
    methods: {
        getRowScheduleValue(dayId){

            if (this.rowScheduleValue !== null){
                const a = this.rowScheduleValue[dayId]
                return a
            }
            return {}
        },
    },
    data() {
        return {
            days
        }
    },
}

</script>

<style scoped>
h3{
    text-align: center !important;
    vertical-align: middle;
}
td{
    background: #d7fcd8;
    display: flex;
    align-items: center;
    justify-content: center
}
th{

}
</style>